import hy from "./hy.json";
import en from "./en.json";

const langs = { hy, en };

export default langs;
